import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ProductoAgricolaService } from '../../_services/producto-agricola.service';
import { ProductoAgricola } from '../../_models/producto-agricola';
import { Seguro } from '../../_models/seguro';
import { SeguroService } from '../../_services/seguro.service';

@Component( {
  selector: 'app-seguro-listado',
  templateUrl: 'seguro-listado.component.html'
} )

export class SeguroListadoComponent implements OnInit {

  seguro: Seguro[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private serSeguro: SeguroService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/seguro' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_NOMBRE' ), sort: true },
      { field: 'indicadorBeneficiario', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_BENEFI' ), sort: true },
      { field: 'nombreCuestionario', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_DECLRIES' ), sort: true },
      { field: 'aseguraNegocio', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_ASEGURANEGOCIO' ), sort: true },
      { field: 'aseguraCasa', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_ASEGURACASA' ), sort: true },
      { field: 'aseguraContenidoHogar', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_ASEGURACONTENIDOHOGAR' ), sort: true },
      { field: 'aseguraContenidoNegocio', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_ASEGURACONTENIDONEGOCIO' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'seguro.component' );

    this.serSeguro.listado().subscribe( seguro => {
      this.seguro = seguro;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crear() {
    this.router.navigate( [ 'apl/seguro/agregar' ] );
  }

  irMetaVenta() {
    this.router.navigate( [ 'apl/seguro/meta-venta' ] );
  }

  ver( regVisualizar: Seguro ) {
    this.router.navigate( [ 'apl/seguro/detalle/' + regVisualizar.idSeguro ] );
  }

  editar( regActualizar: Seguro ) {
    this.router.navigate( [ 'apl/seguro/actualizar/' + regActualizar.idSeguro ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'seguro.component', this.busqueda );
  }
}
